import { Map as ImmutableMap, List } from 'immutable';

export const FETCH_CA = 'ipfabric/Settings/Ldap/FETCH_CA';
export const FETCH_DATA = 'ipfabric/Settings/Ldap/FETCH_DATA';
export const SAVE_FORM = 'ipfabric/Settings/Ldap/SAVE_FORM';
export const DOMAIN_OPTIONS_CHANGE =
  'ipfabric/Settings/Ldap/DOMAIN_OPTIONS_CHANGE';
export const CLEAR_PAGE = 'ipfabric/Settings/Ldap/CLEAR_PAGE';
export const GROUP_SEARCH_DATA_CHANGE =
  'ipfabric/Settings/Ldap/GROUP_SEARCH_DATA_CHANGE';
export const DELETE_CONFIGURATION =
  'ipfabric/Settings/Ldap/DELETE_CONFIGURATION';
export const OPEN_FILE_UPLOAD = 'ipfabric/Settings/Ldap/OPEN_FILE_UPLOAD';
export const CLOSE_FILE_UPLOAD = 'ipfabric/Settings/Ldap/CLOSE_FILE_UPLOAD';
export const CONFIRM_DELETE_ALL_ROLE_ASSIGNMENTS =
  'ipfabric/Settings/Ldap/CONFIRM_DELETE_ALL_ROLE_ASSIGNMENTS';
export const SAVE_GROUP_ERRORS = 'ipfabric/Settings/Ldap/SAVE_GROUP_ERRORS';
export const CLEAR_GROUP_ERROR = 'ipfabric/Settings/Ldap/CLEAR_GROUP_ERROR';
export const CLEAR_GROUP_ERRORS = 'ipfabric/Settings/Ldap/CLEAR_GROUP_ERRORS';
export const FETCH_ROLES = 'ipfabric/Settings/Ldap/FETCH_ROLES';

export const DELETE_CONFIG_DIALOG_NAME = 'ldapDeleteConfigDialog';
export const DELETE_ROLE_ASSIGNMENT_DIALOG_NAME =
  'ldapDeleteRoleAssignmentDialog';
export const PAGE_URL = '/settings/administration/ldap';
export const OPENLDAP_DEFAULTS = {
  searchLogin: new List(['uid']),
};
export const AD_DEFAULTS = {
  searchLogin: new List(['sAMAccountName', 'userPrincipalName']),
};

export const NEW_ROLE_ITEM = new ImmutableMap({
  groupName: 'any',
  roleId: '',
});
